// extracted by css-extract-rspack-plugin
export default {"container":"LeftSection-module__container","section":"LeftSection-module__section"};